export default __webpack_public_path__ + "static/Cementing_Paste-d459d393adbcf414bf7450d34e5a4855.png";